// extracted by mini-css-extract-plugin
export default {"popover-content-container":"_enote3","popoverContentContainer":"_enote3","language":"_wvm3te"};